import { useRef } from 'react'

import { useBoolean } from 'ahooks'
import { Popover } from 'antd'

import { getFirstScrolledParent } from '@eastcoal/common/utils/dom'

import { useEditor } from '@eastcoal/editor/hooks/useEditor'
import { TableCellPanel } from '@eastcoal/editor/ui/TableCellPanel'
import { TableCellPanelRef } from '@eastcoal/editor/ui/TableCellPanel/interface'
import { $insertTable } from '@eastcoal/editor/utils/table'
import { WpsTableIcon } from '@eastcoal/icon/WpsTableIcon'

import { IsolatedButton } from '../IsolatedButton'

export const TableButton = () => {
  const editor = useEditor()
  const [open, openActions] = useBoolean()
  const tableCellPanelRef = useRef<TableCellPanelRef>(null)

  const handleInsertTable = (rows: number, cols: number) => {
    openActions.setFalse()
    editor.update(() => {
      $insertTable(editor, {
        columns: `${cols}`,
        rows: `${rows}`
      })
    })
  }

  return (
    <Popover
      getPopupContainer={triggerNode => getFirstScrolledParent(triggerNode)}
      open={open}
      trigger={['click']}
      afterOpenChange={visible => {
        if (!visible) {
          tableCellPanelRef.current?.reset()
        }
      }}
      content={
        <TableCellPanel
          ref={tableCellPanelRef}
          cols={10}
          rows={8}
          title='插入表格'
          onSelect={handleInsertTable}
        />
      }
      onOpenChange={openActions.toggle}
    >
      <IsolatedButton>
        <WpsTableIcon />
        <span>表格</span>
      </IsolatedButton>
    </Popover>
  )
}
